import { Requests } from "../common/request.common";
import type { DebugToolsResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { buildSelectParam, get, post } from "./common";

export const debugTools = {
    runStandaloneDaemons(data: typeof Requests.DebugTools.StandaloneDaemon.Input) {
        return post<typeof data>(`/debug/daemons/standalone`, data);
    },
    runAssociateDaemons(data: typeof Requests.DebugTools.AssociateDaemon.Input) {
        return post<typeof data>(`/debug/daemons/associate`, data);
    },
    formHooks: {
        selectStandaloneDaemons: (async (param?: SelectParam) => {
            const req = get<DebugToolsResponseTypes.SelectStandaloneDaemons>(
                `/debug/daemons/standalone` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        selectAssociateDaemons: (async (param?: SelectParam) => {
            const req = get<DebugToolsResponseTypes.SelectAssociateDaemons>(
                `/debug/daemons/associate` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
    },
};
